import React, { useContext, useRef, useState } from 'react';
import _ from 'lodash';
import cx from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Grow from '@material-ui/core/Grow';
import Popper from '@material-ui/core/Popper';
import FilterListIcon from '@material-ui/icons/FilterList';
import TableContext from '../TableContext';
import FilterPanel from './FilterPanel';

const useStyles = makeStyles(theme => ({
  icon: {
    fontSize: '0.875rem',
    margin: '0 4px',
    color: 'rgba(0, 0, 0, 0.54)',
    cursor: 'pointer'
  },
  iconActive: {
    color: theme.palette.secondary.main
  }
}));

const FilterButton = ({ column, tableCellRef }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const {
    data,
    getColumnFilter,
    setColumnFilter,
    clearColumnFilters
  } = useContext(TableContext);
  const columnFilter = getColumnFilter(column.name);
  const selectedValues = _.get(columnFilter, 'values', []);

  if (!column.filterable) {
    return null;
  }

  // const columnData = data.map(row => row[column.name]);
  const columnData = data.map(row =>
    row[column.name] ? row[column.name].trim() : row[column.name]
  );
  // .flatMap(v => (v ? v.split(', ') : v));
  //  const columnData =  data.map(row => typeof(row[column.name])==="string"?row[column.name].trim() :"New").flatMap(v => (v ? v.split(', ') : v))
  // const columnData = []
  const columnValues = _.countBy(columnData);

  // console.log('FilterButton');
  // console.log('  -- column', column);
  // console.log('  -- data', data);
  // console.log('  -- columnData', columnData);
  // console.log('  -- columnValues', columnValues);
  // console.log('  -- columnFilter', columnFilter);
  // console.log('  -- selectedValues', selectedValues);

  const toggleFilterPanel = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const closeFilterPanel = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleFilterChange = newSelectedValues => {
    setColumnFilter(column.name, newSelectedValues);
  };

  const handleFilterClear = () => {
    clearColumnFilters(column.name);
  };

  const iconRootClasses = cx(classes.icon, {
    [classes.iconActive]: selectedValues.length > 0
  });

  return (
    <>
      <FilterListIcon
        classes={{ root: iconRootClasses }}
        onClick={event => {
          event.preventDefault();
          event.stopPropagation();
          toggleFilterPanel();
          return false;
        }}
        ref={anchorRef}
      />
      <Popper
        open={open}
        anchorEl={tableCellRef.current}
        role={undefined}
        transition
        disablePortal
        placement="bottom-start"
        style={{ zIndex: 1000 }}
        modifiers={{
          flip: {
            enabled: true
          },
          preventOverflow: {
            enabled: true,
            boundariesElement: 'viewport',
            padding: 20
          },
          offset: {
            offset: '0,5'
          }
        }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom-start' ? 'center top' : 'center bottom'
            }}
          >
            <FilterPanel
              columnValues={columnValues}
              selectedValues={selectedValues}
              onPanelClose={closeFilterPanel}
              onFilterChange={handleFilterChange}
              onFilterClear={handleFilterClear}
            />
          </Grow>
        )}
      </Popper>
    </>
  );
};

export default FilterButton;
